module.exports = __webpack_public_path__ + "img/HKLII_logotype.83e6ea82.svg";